import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dRational$dSerialized from "../Data.Rational.Serialized/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dMenu$dV2$dPackaging from "../Restaumatic.Menu.V2.Packaging/index.js";
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
  return x => $0(Data$dMap$dInternal.keys(x));
})();
const toUnfoldable1 = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const notTooLargeContainers = dictOrd => {
  const filterWithKey = Data$dMap$dInternal.filterWithKey((() => {
    const $0 = dictOrd.Eq0();
    const eqContainer1 = {eq: v => v1 => $0.eq(v._1.details)(v1._1.details)};
    return {compare: v => v1 => dictOrd.compare(v._1.details)(v1._1.details), Eq0: () => eqContainer1};
  })());
  const $0 = dictOrd.Eq0();
  return map1 => filterWithKey(v => {
    const $1 = v._1.capacity;
    return containeds => !(
      Data$dRational$dSerialized.ordRational.compare($1)(Data$dFoldable.foldlArray(vol => contained => Data$dRational$dSerialized.semiringRational.add(vol)(contained.allowedContainers.length === 0
        ? Data$dRational$dSerialized.semiringRational.zero
        : contained.volume))(Data$dRational$dSerialized.semiringRational.zero)(containeds)).tag === "GT"
    ) || (() => {
      const $2 = Data$dArray.indexImpl(
        Data$dMaybe.Just,
        Data$dMaybe.Nothing,
        Data$dArray.sortWith(Data$dRational$dSerialized.ordRational)(v$1 => v$1._1.capacity)(toUnfoldable(Data$dMap.keys(map1))),
        0
      );
      if ($2.tag === "Just") { return $0.eq(v._1.details)($2._1._1.details); }
      return false;
    })();
  })(map1);
};
const largestContainerWithContainedsFittingIn = dictOrd => map1 => {
  const v = Data$dArray.indexImpl(
    Data$dMaybe.Just,
    Data$dMaybe.Nothing,
    Data$dArray.sortBy(v1 => {
      const $0 = v1._1._1.capacity;
      return v2 => Data$dRational$dSerialized.ordRational.compare(v2._1._1.capacity)($0);
    })(toUnfoldable1(map1)),
    0
  );
  if (v.tag === "Nothing") { return Data$dMaybe.Nothing; }
  if (v.tag === "Just") {
    const $0 = v._1._1._1.capacity;
    return Data$dMaybe.$Maybe(
      "Just",
      Data$dTuple.$Tuple(
        v._1._1,
        Data$dFoldable.foldlArray(v2 => {
          const $1 = v2._2;
          const $2 = v2._1;
          return v3 => {
            const newVol = Data$dRational$dSerialized.semiringRational.add($2)(v3.volume);
            if (!(Data$dRational$dSerialized.ordRational.compare(newVol)($0).tag === "GT")) { return Data$dTuple.$Tuple(newVol, Data$dSemigroup.concatArray([v3])($1)); }
            return v2;
          };
        })(Data$dTuple.$Tuple(Data$dRational$dSerialized.semiringRational.zero, []))(v._1._2)._2
      )
    );
  }
  $runtime.fail();
};
const containedsByEligibleContainers = dictOrd => containeds => Data$dFoldable.foldlArray(m1 => m2 => Data$dMap$dInternal.unsafeUnionWith(
  v => v1 => dictOrd.compare(v._1.details)(v1._1.details),
  Data$dSemigroup.concatArray,
  m1,
  m2
))(Data$dMap$dInternal.Leaf)(Control$dBind.arrayBind(containeds)(contained => Data$dFunctor.arrayMap(a => Data$dMap$dInternal.$$$Map(
  "Node",
  1,
  1,
  a,
  [contained],
  Data$dMap$dInternal.Leaf,
  Data$dMap$dInternal.Leaf
))((() => {
  const $0 = contained.volume;
  return Data$dArray.filterImpl(v1 => !(Data$dRational$dSerialized.ordRational.compare(v1._1.capacity)($0).tag === "LT"), contained.allowedContainers);
})())));
const minNumberOfContainersHeuristic = dictOrd => {
  const difference = Data$dFoldable.foldrArray(Data$dArray.delete(Restaumatic$dMenu$dV2$dPackaging.eqContained(dictOrd.Eq0())));
  return containeds => {
    const v = largestContainerWithContainedsFittingIn(dictOrd)(containedsByEligibleContainers(dictOrd)(containeds));
    if (v.tag === "Nothing") { return []; }
    if (v.tag === "Just") { return Data$dSemigroup.concatArray([v._1])(minNumberOfContainersHeuristic(dictOrd)(difference(containeds)(v._1._2))); }
    $runtime.fail();
  };
};
export {containedsByEligibleContainers, largestContainerWithContainedsFittingIn, minNumberOfContainersHeuristic, notTooLargeContainers, toUnfoldable, toUnfoldable1};
